//token user login actions
export const SET_USER_TOKEN_DATA = "SET_USER_TOKEN_DATA";
export const REMOVE_USER_TOKEN_DATA = "REMOVE_USER_TOKEN_DATA";
export const SET_SELF_USER_DATA = "SET_SELF_USER_DATA";
export const REMOVE_USER_DATA = "REMOVE_USER_DATA";

//ride actions
export const SET_RIDE_REQUESTS = "SET_RIDE_REQUESTS";
export const ADD_RIDE_REQUEST = "ADD_RIDE_REQUEST";
export const UPDATE_RIDE_REQUEST = "UPDATE_RIDE_REQUEST";
